export const CATEGORIES_ROOT_NAME = 'root'
export const CATEGORIES_PRINT_ON_DEMAND_ROOT_NAME = 'print_on_demand_root'
